export default "__VITE_ASSET__8TZSil3q__"